









import {Component, Mixins} from 'vue-property-decorator'
import ProductCard from "@/helpers/mixins/ProductCard";
import {Coupon} from "@/helpers/interfaces";
import api from "@/api/api";
import sortCoupon from '@/helpers/sortCoupon';
import CouponBoxListDisplayOnly from '@/components/layout/Coupon/CouponBoxListDisplayOnly.vue';


@Component({
  components: {CouponBoxListDisplayOnly}
})
export default class CouponBox  extends Mixins(ProductCard) {
  public couponList: Coupon[] = []

  created(){
    this.fetchData()
  }

  public async fetchData(){
    try {
      const res = await api.getHomePageCoupons(3)
      this.couponList = res.data
      this.couponList = sortCoupon(this.couponList)
    } catch (e) {
      console.log(e)
    }
  }

}
